import { render, staticRenderFns } from "./PublicProcessBOM.vue?vue&type=template&id=04ff35b2&"
import script from "./PublicProcessBOM.vue?vue&type=script&lang=js&"
export * from "./PublicProcessBOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports